import { ToggleButtonDesignTokens } from '@primeuix/themes/aura/togglebutton';

export const toggleButtonTokens: ToggleButtonDesignTokens = {
  root: {
    borderRadius: '{content.border.radius}',
    gap: '0.5rem',
    fontWeight: '500',
    padding: '0.25rem',
    disabledBackground: '{form.field.disabled.background}',
    disabledBorderColor: '{form.field.disabled.background}',
    disabledColor: '{form.field.disabled.color}',
    invalidBorderColor: '{form.field.invalid.border.color}',
    transitionDuration: '{form.field.transition.duration}',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      offset: '{focus.ring.offset}',
      shadow: '{focus.ring.shadow}',
    },
    sm: {
      fontSize: '{form.field.sm.font.size}',
      padding: '0.25rem',
    },
    lg: {
      fontSize: '{form.field.lg.font.size}',
      padding: '0.25rem',
    },
  },
  icon: {
    disabledColor: '{form.field.disabled.color}',
  },
  content: {
    padding: '0.125rem 0.75rem',
    borderRadius: '0.25rem',
    checkedShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.02), 0 1px 2px 0 rgba(0, 0, 0, 0.04)',
    sm: {
      padding: '0.25rem 0.75rem',
    },
    lg: {
      padding: '0.25rem 0.75rem',
    },
  },
  colorScheme: {
    light: {
      root: {
        background: 'rgba(46, 16, 101, 0.05)',
        borderColor: 'none',
        checkedBackground: 'rgba(46, 16, 101, 0.05)',
        checkedColor: '{text.color}',
        checkedBorderColor: 'none',
        hoverBackground: '{surface.100}',
        hoverColor: '{surface.700}',
        color: 'rgba(46, 16, 101, 0.64)',
      },
      icon: {
        color: 'rgba(46, 16, 101, 0.64)',
        hoverColor: '{text.color}',
        checkedColor: '{text.color}',
      },
      content: {
        checkedBackground: '{surface.0}',
      },
    },
    dark: {
      root: {
        background: '#282648',
        borderColor: 'none',
        checkedBackground: '#282648',
        checkedColor: '{surface.100}',
        checkedBorderColor: 'none',
        hoverBackground: '#282648',
        hoverColor: '{surface.200}',
        color: '{surface.300}',
      },
      icon: {
        color: '{surface.300}',
        hoverColor: '{surface.200}',
        checkedColor: '{surface.100}',
      },
      content: {
        checkedBackground: '{primary.950}',
      },
    },
  },
};
